/**
 * Groups-only trading gate — FE mirror of the backend activation 400.
 *
 * Only group engines may trade: activating a rule on a pair with no opener
 * group is refused by the backend ("Pair is not assigned to an opener group
 * …"). The activation switches mirror that contract visually — an UNGROUPED
 * pair's OFF switch is disabled with a tooltip instead of letting the
 * operator click into a guaranteed rejection.
 *
 * Turning OFF is never blocked: an already-armed flag on an ungrouped pair
 * (legacy state predating groups-only trading) must stay operable so the
 * operator can always disarm it.
 */
export const UNGROUPED_ACTIVATION_TOOLTIP =
  'Assign the pair to a group to trade';

export function isActivationBlocked(
  pair: { openerGroupId?: string | null },
  currentlyOn: boolean
): boolean {
  return pair.openerGroupId == null && !currentlyOn;
}

/**
 * Whether arming a maker leg must FIRST auto-enable the pair's opener kill
 * switch. The backend refuses to activate a rule on an `openerEnabled: false`
 * pair (`assertPairOpenerEnabled` → 400 "Pair is turned OFF for the opener"),
 * so without this the arm PATCH rolls back and the switch snaps back to OFF
 * (operator report: "lo prendo y vuelve a apagarse, no refresca"). The
 * operator chose to auto-enable the pair in the same gesture rather than be
 * blocked. Only relevant when ARMING (`arming === true`); disarming never
 * needs the pair on. A pair already enabled (or unknown) needs no auto-enable.
 */
export function needsOpenerAutoEnable(
  pair: { _id?: string; openerEnabled?: boolean },
  arming: boolean
): boolean {
  return arming && !!pair._id && pair.openerEnabled === false;
}
